import { useEffect, useRef, useState } from 'preact/hooks';
import { isTestKeysBackend } from '@/session';
import { logWarn } from '@/sdkConsole';

const TEST_CARD_NUMBER = '4242 4242 4242 4242';
const COPIED_RESET_MS = 1500;

// Test-keys-only callout above the payment element: publishers testing the
// checkout don't know Stripe's test card numbers offhand. The copy button
// puts the number on the clipboard.
export function TestCardHint() {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (resetTimer.current != null) window.clearTimeout(resetTimer.current);
    };
  }, []);

  if (!isTestKeysBackend()) {
    return null;
  }

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(TEST_CARD_NUMBER);
      setCopied(true);
      resetTimer.current = window.setTimeout(() => setCopied(false), COPIED_RESET_MS);
    } catch (err) {
      logWarn('test card copy failed', err);
    }
  };

  return (
    <div class="sm-testcard-hint">
      <div class="sm-testcard-hint-head">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M7 2v2h1v14a4 4 0 0 0 4 4 4 4 0 0 0 4-4V4h1V2H7zm3 14c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm2-4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-5h-4V4h4v3z" />
        </svg>
        <span class="sm-testcard-hint-title">Test card</span>
        <button type="button" class="sm-testcard-hint-copy" onClick={copy}>
          <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M19 21H8V7h11m0-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-3-4H4a2 2 0 0 0-2 2v14h2V3h12V1z" />
          </svg>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <div class="sm-testcard-hint-number">{TEST_CARD_NUMBER}</div>
      <div class="sm-testcard-hint-meta">Any future expiry &middot; any CVC</div>
    </div>
  );
}
